import './user-header.scss';
import React, {useEffect, useState} from 'react';
import {LogoutButton} from './logout-button/logout-button';
import {SessionManager} from '../../utilities/session-management/session-manager';
import {JegerwebApiService} from '../../services/api-service/jegerweb-api-service';

export const UserHeader: React.FC = () => {
  const [isReady, setReady] = useState(false);
  const [jegerdata, setJegerdata] = useState<{ jeger?: { navn?: string } }>({});

  useEffect(() => {
    if (SessionManager.session) {
      setReady(SessionManager.session.isReady());
      SessionManager.session.addReadyChangeListener((b) => {
        setReady(b);
      });
    }
  }, []);

  useEffect(() => {
   /* console.log('isReady:', isReady);*/
    if (isReady) {
      JegerwebApiService.get('/jeger/:sessiontype/navn')
          .then(response => {
           /* console.log('API response:', response.data);*/
            if (response.data) {
              setJegerdata({ jeger: { navn: response.data } });
            } else if (response.data && response.data.jeger) {
              setJegerdata(response.data);
            } else {
          /*    console.warn('API response mangler "jeger" objekt:', response.data);*/
              setJegerdata({ jeger: { navn: 'Ukjent' } });
            }
          })
          .catch(err => {
            /* console.error('Nettverksfeil:', err);*/
            setJegerdata({ jeger: { navn: 'Feil ved lasting' } });
          });
    }
  }, [isReady]);

  return (
      <header className="user-header no-print">
        <div className="user-header__inner center">
          <p className="user-header__fullname">{jegerdata?.jeger?.navn || 'Laster...'}</p>
          <LogoutButton />
        </div>
      </header>
  );
};
